import React from "react";
import { FontWeightEnum } from "../../types/AppTypes";
import { BodyTyp } from "../Typography/Typography";
import { StyledLegendDot, StyledDot } from "./LegendLabelDot.styled";

type LegendLabelDotProps = {
  color?: string;
  label?: string;
  fontWeight?: FontWeightEnum;
  variant?: string;
};

export const LegendLabelDot = ({
  color,
  label,
  fontWeight,
  variant,
}: LegendLabelDotProps) => {
  if (!color) return null;

  return (
    <StyledLegendDot>
      <StyledDot $color={color} aria-hidden="true" />
      {label && (
        <BodyTyp fontWeight={fontWeight} variant={variant}>
          {label}
        </BodyTyp>
      )}
    </StyledLegendDot>
  );
};
